import { render, staticRenderFns } from "./LaboralDashboardV1.vue?vue&type=template&id=5b47b559&"
import script from "./LaboralDashboardV1.vue?vue&type=script&lang=js&"
export * from "./LaboralDashboardV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports